host.actions.register({
    // #region Vars
    name: '288a.commerce.cart.create',
    // #endregion
    // #region Entry
    async execute(data, params) {
        return this.Window(await host.notification.showModal2(host.components.getComponent('g-cart-create-dialog'), { ...data, ...params }));
    },
    // #endregion
});
export {};
